export default __webpack_public_path__ + "static/media/social-media-2786261_1920.ac7dc1d0.jpg";